import { createActionGroup, } from "@ngrx/store";
import { Lead } from "../models/lead/lead.model";
import { User } from "../models/user/user.model";


export const LeadActions = createActionGroup({
    source: 'Shared',
    events: {
        'lead requested auto assign': (leadId: number) => ({ leadId }),
        'lead rejected': (leadId: number | string) => ({ leadId }),
        'lead created': (lead: Lead) => ({ lead }),
        'lead info modified': (lead: Lead) => ({ lead }),
        'lead qualified': (leadId: number | string) => ({ leadId }),
        'lead offer accepted': (leadId: number | string) => ({ leadId }),
        'lead offer refused': (leadId: number | string) => ({ leadId }),
        'lead assigned': (leadId: number, user: User) => ({ leadId, user }),
        'lead offered': (leadId: number, user: User) => ({ leadId, user }),
        'lead assignation revoked': (leadId: number) => ({ leadId }),
        'lead offer revoked': (leadId: number) => ({ leadId }),
        'leads imported': (count: number) => ({ count })
    }
})











